import { render, staticRenderFns } from "./recharge_edit.vue?vue&type=template&id=20821fcb&scoped=true&"
import script from "./recharge_edit.vue?vue&type=script&lang=js&"
export * from "./recharge_edit.vue?vue&type=script&lang=js&"
import style0 from "./recharge_edit.vue?vue&type=style&index=0&id=20821fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20821fcb",
  null
  
)

export default component.exports